import { Icon } from '@iconify/react'
import { type FC, useEffect, useState } from 'react'

import { APPOINTMENT_CATEGORY_NAMES, PATIENT_STATUSES } from 'features/Home/constants/infoConstants'
import { useChartScheduleData } from 'features/Procedure/hooks/useChartScheduleData'
import { ManageEhrAppointment } from 'features/Schedule/pages/components/ManageAppointment/ManageEhrAppointment'
import { EScheduleView } from 'features/Schedule/pages/Schedule'
import styles from './add-chart-appointment.module.scss'

type AddChartAppointmentProps = {
  disabled?: boolean
}

export const AddChartAppointment: FC<AddChartAppointmentProps> = ({ disabled = false }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedDate, setSelectedDate] = useState<string | null>(null)
  const scheduleData = useChartScheduleData(selectedDate || undefined)

  useEffect(() => {
    if (!isOpen) {
      setSelectedDate(null)
    }
  }, [isOpen])

  if (!scheduleData.isAvailable) return null

  const categoryOverride = scheduleData.isJessicaSite
    ? APPOINTMENT_CATEGORY_NAMES.OFFICE_VISIT
    : undefined
  const statusOverride = scheduleData.isJessicaSite ? PATIENT_STATUSES.IN_EXAM_ROOM : undefined

  return (
    <>
      <button
        type='button'
        className={styles.iconButton}
        onClick={() => setIsOpen(true)}
        disabled={disabled}
        title='Add Appointment'>
        <Icon icon='ph:calendar-plus' width={18} height={18} />
      </button>
      <ManageEhrAppointment
        scheduleView={EScheduleView.DAY}
        open={isOpen}
        isEditing={false}
        setOpen={() => setIsOpen(false)}
        date={scheduleData.date}
        rooms={scheduleData.rooms}
        schedules={scheduleData.schedules}
        consultation_staffs={scheduleData.consultationStaffs}
        languages={scheduleData.languages}
        appointmentCategories={scheduleData.appointmentCategories}
        patientStatuses={scheduleData.patientStatuses}
        punctuality={scheduleData.punctuality}
        patientBufferTime={scheduleData.patientBufferTime}
        byPassTemperatureCheck={scheduleData.byPassTemperatureCheck}
        timeInterval={scheduleData.timeInterval}
        dayInterval={scheduleData.timeInterval}
        disabledIntervals={[]}
        timeZone={scheduleData.timeZone}
        isSendingNotifications={false}
        prePopulateSchedule={null}
        initialCategoryName={categoryOverride}
        initialStatusCode={statusOverride}
        onDateChange={setSelectedDate}
      />
    </>
  )
}
